import React, { useContext } from "react";

const SendMessageIcon = (props) => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="22"
        height="18"
        viewBox="0 0 22 18"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.5 7L0.51 0L21.5 9L0.51 18L0.5 11L15.5 9L0.5 7ZM2.51 3.03L10.02 6.25L2.5 5.25L2.51 3.03ZM10.01 11.75L2.5 14.97V12.75L10.01 11.75Z"
          fill={props.color}
          fillOpacity="0.66"
        />
      </svg>
    </>
  );
};

export default SendMessageIcon;
